import { useCallback } from 'react';
import { useHref, useLinkClickHandler } from 'react-router-dom';
import type { To } from 'react-router-dom';

export function useRouterLinkProps(params: useRouterLinkProps.Params) {
    const { to, target, replace = false, reloadDocument, state, onClick: paramsOnClick } = params;

    const href = useHref(to);
    const internalOnClick = useLinkClickHandler(to, { replace, state, target });

    const onClick = useCallback(
        (ev: React.MouseEvent<HTMLAnchorElement>) => {
            paramsOnClick?.(ev);
            if (!ev.defaultPrevented && !reloadDocument) {
                internalOnClick(ev);
            }
        },
        [internalOnClick, paramsOnClick, reloadDocument],
    );

    return {
        href,
        onClick,
    };
}

export namespace useRouterLinkProps {
    type LinkProps = React.ComponentPropsWithoutRef<'a'>;

    export interface Params extends Pick<LinkProps, 'onClick' | 'target'> {
        to: To;
        reloadDocument?: boolean;
        replace?: boolean;
        // state is typed like `useLinkClickHandler` prop
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        state?: any;
    }
}
